// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__W5Kpf","emails":"CreateEditClinics_emails__1vEyY","emailTagLabel":"CreateEditClinics_emailTagLabel__1qlU1"};